/**
 * Centralizované statusy pre Supabase tabuľky
 * Jediný zdroj pravdy – všetky dotazy/filtre musia používať tieto hodnoty.
 *
 * DÔLEŽITÉ: Nepleťte si statusy medzi tabuľkami!
 * - users: approved (nie confirmed)
 * - private_lessons: approved (nie confirmed)
 * - group_signups: confirmed (nie approved)
 */

// =============================================================================
// USERS (auth.users rozšírené cez public.users)
// =============================================================================
export const USER_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS];

// =============================================================================
// PAIRS
// =============================================================================
export const PAIR_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
} as const;

export type PairStatus = (typeof PAIR_STATUS)[keyof typeof PAIR_STATUS];

// =============================================================================
// GROUP_LESSONS
// =============================================================================
export const GROUP_LESSON_STATUS = {
  PENDING: "pending",
  SCHEDULED: "scheduled",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export type GroupLessonStatus =
  (typeof GROUP_LESSON_STATUS)[keyof typeof GROUP_LESSON_STATUS];

// =============================================================================
// GROUP_SIGNUPS (prihlášky na skupinové lekcie)
// =============================================================================
export const GROUP_SIGNUP_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  CHECKED_IN: "checked_in",
  CANCELLED: "cancelled",
} as const;

export type GroupSignupStatus =
  (typeof GROUP_SIGNUP_STATUS)[keyof typeof GROUP_SIGNUP_STATUS];

// =============================================================================
// PRIVATE_LESSONS (súkromné lekcie)
// V aplikácii používame len: pending | approved | completed | cancelled
// (DB constraint môže obsahovať aj legacy 'confirmed' – nepoužívať)
// =============================================================================
export const PRIVATE_LESSON_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export type PrivateLessonStatus =
  (typeof PRIVATE_LESSON_STATUS)[keyof typeof PRIVATE_LESSON_STATUS];

/** Aktívne statusy súkromnej lekcie (zobrazovať v kalendári / budúce) */
export const PRIVATE_LESSON_ACTIVE_STATUSES: PrivateLessonStatus[] = [
  PRIVATE_LESSON_STATUS.PENDING,
  PRIVATE_LESSON_STATUS.APPROVED,
];

// =============================================================================
// AVAILABILITY_SLOTS
// =============================================================================
export const AVAILABILITY_SLOT_STATUS = {
  FREE: "free",
  BOOKED: "booked",
  BLOCKED: "blocked",
  PENDING: "pending", // Návrh od používateľa, čaká na schválenie admina
} as const;

export type AvailabilitySlotStatus =
  (typeof AVAILABILITY_SLOT_STATUS)[keyof typeof AVAILABILITY_SLOT_STATUS];

// =============================================================================
// DANCE_GROUPS
// =============================================================================
export const DANCE_GROUP_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

// =============================================================================
// GROUP_MEMBERS
// =============================================================================
export const GROUP_MEMBER_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  DECLINED: "declined",
  REMOVED: "removed",
} as const;

// =============================================================================
// GROUP_COURSES (group_courses tabuľka)
// =============================================================================
export const GROUP_COURSE_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;
